import React, { useEffect, useState } from 'react';
import { Form, Select, Input } from 'antd';

const { Option } = Select;

const CArticuloElectronicaEmpresa = () => {
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [modelosFiltrados, setModelosFiltrados] = useState([]);

  useEffect(() => {
    const fetchDatos = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/electronica/auxiliares`);
        const data = await res.json();
        setMarcas(data.marcas);
        setModelos(data.modelos);
      } catch (error) {
        console.error('Error al obtener datos auxiliares de electrónica:', error);
      }
    };

    fetchDatos();
  }, []);

  const onMarcaChange = (marcaId) => {
    const filtrados = modelos.filter(m => m.modelo_marca_id === marcaId);
    setModelosFiltrados(filtrados);
  };

  return (
    <>
      <Form.Item name="marca_modelo" label="Marca">
        <Select placeholder="Seleccione una marca" onChange={onMarcaChange} allowClear>
          {marcas.map(m => (
            <Option key={m.marca_id} value={m.marca_id}>{m.marca_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="modelo" label="Modelo">
        <Select placeholder="Seleccione un modelo" allowClear>
          {modelosFiltrados.map(m => (
            <Option key={m.modelo_id} value={m.modelo_nombre}>{m.modelo_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="voltaje" label="Voltaje"><Input /></Form.Item>
      <Form.Item name="tipo_bateria" label="Tipo de Batería"><Input /></Form.Item>
      <Form.Item name="conectividad" label="Conectividad"><Input /></Form.Item>
      <Form.Item name="garantia" label="Garantía"><Input /></Form.Item>
    </>
  );
};

export default CArticuloElectronicaEmpresa;